import {
  ChainNotConfiguredError,
  SwitchChainNotSupportedError,
  type AddEthereumChainParameter,
  type BaseErrorType,
  type ChainNotConfiguredErrorType,
  type ConnectorParameter,
  type ErrorType,
  type Evaluate,
  type ExactPartial,
  type ProviderNotFoundErrorType,
  type SwitchChainNotSupportedErrorType,
  type UserRejectedRequestErrorType,
} from '@particle-network/connector-core';
import type { Chain } from 'viem';
import type { Config } from '../createConfig';

export type SwitchChainParameters = Evaluate<
  ConnectorParameter & {
    chainId: number;
    addEthereumChainParameter?: Evaluate<ExactPartial<Omit<AddEthereumChainParameter, 'chainId'>>> | undefined;
  }
>;

export type SwitchChainReturnType = Chain;

export type SwitchChainErrorType =
  | SwitchChainNotSupportedErrorType
  | ChainNotConfiguredErrorType
  | ProviderNotFoundErrorType
  | UserRejectedRequestErrorType
  | BaseErrorType
  | ErrorType;

export async function switchChain(config: Config, parameters: SwitchChainParameters): Promise<SwitchChainReturnType> {
  const { addEthereumChainParameter, chainId } = parameters;

  const connection = config.state.connections.get(parameters.connector?.uid ?? config.state.current!);
  if (connection) {
    const connector = connection.connector;
    if (!connector.switchChain) throw new SwitchChainNotSupportedError({ connector });
    const chain = await connector.switchChain({
      addEthereumChainParameter,
      chainId,
    });
    return chain;
  }

  const chain = config.chains.find((x) => x.id === chainId);
  if (!chain) throw new ChainNotConfiguredError();
  config.setState((x) => ({ ...x, chainId }));
  return chain;
}
